import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }

import { useGetTypeDeviceModel } from '@/entities/type/hooks';
import {
  reactive,
  ref,
  computed,
  PropType, Ref,
} from 'vue';

import { set } from 'lodash';

import { minValue, required } from '@vuelidate/validators';
import { ValidationRuleCollection } from '@vuelidate/core';

import { useForm } from '@/core/hooks/forms';

import {
  useGetDeviceQuery,
  useUpdateDeviceMutation,
} from '@/entities/device/hooks';

import { useGetAttributesQuery } from '@/entities/attribute/hooks';

import { Attribute } from '@/entities/attribute/types';
import { Device, DeviceModelFormFieldType } from '@/entities/device/types';

import {
  NkForm,
  NkButton,
  NkGroup,
  NkStack,
} from '@/core/components';

import DeviceModelFromPartField
  from '@/entities/device/components/form/DeviceModelFormPartField.vue';
import { ElNotification } from 'element-plus';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceUpdateForm',
  props: {
  id: {
    type: Number as PropType<Device['id']>,
    required: true,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n();


const { onSubmitted } = useForm(emit);



const form = ref();

const rules = reactive({});
const fields = reactive<Record<string, DeviceModelFormFieldType>>({} as unknown as Record<string, DeviceModelFormFieldType>);

const deviceData = computed(() => ({ id: props.id }));

const { data: attributes } = useGetAttributesQuery();

const hasDeviceQueryData = computed(() => (!!attributes.value?.length && !!deviceData.value.id));
const { data: device } = useGetDeviceQuery(deviceData, {
  refetchOnWindowFocus: false,
  enabled: hasDeviceQueryData,
});

const modelQueryData: Ref = computed(() => ({ id: device.value?.type }));
const hasModelQueryData = computed(() => !!modelQueryData.value.id);
const { isFetched } = useGetTypeDeviceModel(modelQueryData, {
  refetchOnWindowFocus: false,
  enabled: hasModelQueryData,
  onSuccess: (data) => {
    Object.entries(data.deviceValues).forEach(([key, value]) => {
      const rule: ValidationRuleCollection = {};
      const attribute = attributes.value?.find((attr: Attribute) => attr.reference === value.reference);

      if (attribute) {
        if (attribute.isRequired) {
          rule.required = required;
        }

        if (attribute.attributType === 'float') {
          rule.minValue = minValue(.5);
        }

        if (attribute.attributType === 'int') {
          rule.minValue = minValue(1);
        }
      }

      set(rules, key, { value: rule });
      set(fields, key, {
        ...value,
        value: device.value?.deviceValues?.find(o => o.reference === value.reference)?.value || value.value,
      });
    });
  },
});

const {
  mutateAsync,
  isError,
  error,
  isLoading: updateDeviceLoading,
} = useUpdateDeviceMutation();

const handleSubmit = () => {
  if (!updateDeviceLoading.value) {
    form.value.validator.$validate().then((valid: boolean) => {
      if (valid) {
        mutateAsync(({
          ...device.value,
          deviceValues: [...Object.values(fields).map(({ reference, value }) => ({
            reference,
            value,
          }))],
        } as Device),
          {
            onSuccess: () => {
              ElNotification({
                type: 'success',
                title: t('device.notification.update.title'),
                message: t('device.notification.update.message'),
                position: 'bottom-right',
              });
          }
          }).then((data) => {
            onSubmitted(data);
        });
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: fields,
    rules: rules
  }, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkButton), {
            icon: "NkInput",
            type: "primary",
            onClick: _withModifiers(handleSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('device.action.edit')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), { spacing: 3 }, {
        default: _withCtx(() => [
          (_unref(isFetched))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(fields, (deviceValue, i) => {
                return (_openBlock(), _createBlock(DeviceModelFromPartField, {
                  key: deviceValue.reference,
                  model: deviceValue,
                  "field-path": i
                }, null, 8, ["model", "field-path"]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (_unref(isError))
      ? {
          name: "header",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_ElAlert, {
              type: "error",
              "show-icon": ""
            }, {
              default: _withCtx(() => [
                (_unref(error)?.message)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(error)?.message || _unref(error)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(isError)]
            ])
          ])
        }
      : undefined
  ]), 1032, ["fields", "rules"])), [
    [_directive_loading, _unref(updateDeviceLoading)]
  ])
}
}

})